/* template */
<template><div><error-page :errno="(pageErrno)" v-if="(pageErrno)"/><div :class="({ 'page-index-v2': true, 'is-browser': isBrowser })" v-else><div class="fixed-part"><navigation-bar :page-status="(pageStatus)" :city-name="(cityName)" :city-id="(cityId)" :exist-card="(existCard)" @change-page="onChangePage" @share-click="onShareClick"/><tab-bar :city-name="(cityName)" :city-id="(cityId)" :page-status="(pageStatus)" :exist-card="(existCard)" @change-page="onChangePage" v-if="(isMiniProgram && existCard)"/><money-saving-tips :money-saving="(moneySavingBar.moneySaving)" :availabel-coupons="(moneySavingBar.availabelCoupons)" :activities-progress-length="(activitiesInProgress.goods.length)" :bubble-image="(moneySavingBar.bubbleImage)" @money-saving-click="onMoneySavingClick" v-if="(isLogin && pageStatus === EnumMallPageStatus.SaveMoneySet)"/><money-saving-card-tips :money-saving="(cardSavingMoney.save_money)" :availabel-coupons="(0)" @money-saving-click="onCardMoneySavingClick" v-if="(isLogin && pageStatus === EnumMallPageStatus.SaveMoneyCard)"/><login-control @logiuserSaveInfon="onLogin" v-if="(!isLogin)"/><div class="city-select-index-wrap" v-if="(isMiniProgram && !activitiesInProgress.goods.length && !existCard)"><btn-city-select :city-name="(cityName)" :city-id="(cityId)" class="city-select-index"/></div></div><div class="page-content" v-if="(pageStatus === EnumMallPageStatus.SaveMoneySet || !existCard)"><activities-in-progress :type="(activitiesInProgress.type)" :goods-list="(activitiesInProgress.goods)" :algorithm-event="(activitiesInProgress.algorithmEvent)" :city-name="(cityName)" :city-id="(cityId)" :exist-card="(existCard)" v-if="(activitiesInProgress.goods.length)"/><goods-list :cates="(cates)" :active-cate="(activeCate)" :test-old-list="(ABTest.AllGoodsType === 2)" :has-recommend="(!!activitiesInProgress.goods.length)"/></div><div class="page-content-card" v-if="(pageStatus === EnumMallPageStatus.SaveMoneyCard && existCard)"><div class="card-mall-wrap"><pay-card v-for="(cardData, listIndex) in (cardList)" :key="cardData['{{ listIndex }}']" :cardData="(cardData)" :city-id="(cityId)"/></div></div><popup-save-money :user-save-info="(pageStatus === EnumMallPageStatus.SaveMoneySet ? moneySavingPop.info : cardSavingMoney)" :page-status="(pageStatus)" @handleClose="onMoneySavingPopClose" v-if="(moneySavingPop.show)"/></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mb155b2e0"}'>
@import './index.styl'
.page-content-card
  margin-top 16rpx
  background-image linear-gradient(0deg, #F0ECEC 36%, #FEF5F5 72%, #FFFDFD 88%)
  border-radius 42rpx 42rpx 0 0
  padding 42rpx 0
  flex 1
  overflow hidden
  .card-mall-wrap
    height 100%
    overflow-y auto
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createPage } from '@mpxjs/core'
import { is, invokeShare, canIUse, query, xenv, utils } from '@didi/webx-js'
import { EnumMallPageStatus, EnumUIActivitiesInProgressType } from '@/lib/webx/defines'
import { dealPageErrno, request } from '../../lib/webx/api'
import { GlobalConfig } from '../../lib/webx/config'
import { GlobalEnv, setPageShareConfig, URLQueries } from '../../lib/webx'
import { track } from '../../lib/webx/mpx/mixins/pay_card/track'
import { initEnv } from '../../lib/webx/global_env'
import { getParamsPartitionIdByXenv } from '../../lib/webx/global_env/partition_id'
import { TrackMap } from '@/lib/webx/common_methods/track_map'
import { getErrorMessage } from '../../lib/webx/utils/error'
import { getCardList } from '../../api'
import { callIsLogin } from '../../lib/webx/global_env/login'
import { MASErrorTrackIndexHomePageError } from '../../lib/webx/mas_error_track'
import { setTitle, cannotUseHarmonyosShare } from '../../lib/js/util'
import { preloadTrack } from '../../lib/webx/utils/preload_track'

createPage({
  async onLoad() {
    window.PerfTrack?.jsReady?.()
    console.log('window.location.href6789', xenv(), window.location.href)
    utils.resetFontSize()
    await initEnv({ needLocation: true })
    this.cityId = GlobalEnv.locationInfo.cityId
    if (this.firstRequest) {
      if (this.showPayCardTab) {
        // 添加请求省钱卡列表
        await this.getCardListData()
        await this.getHomePage()
      } else {
        await this.getHomePage()
        await this.getCardListData()
      }
      this.firstRequest = false
    }

    utils.pageShow.on(() => {
      !this.firstRequest && this.updateRecommend()
    })
    document.getElementById('loading') && (document.getElementById('loading').style.display = 'none')
    this.shareData = await setPageShareConfig()
  },
  async onShow() {
    await initEnv({ needLocation: true })
    setTitle(this.$t('home.title'))
    if (GlobalEnv.locationInfo.cityId !== this.cityId) {
    // if (!this.firstRequest) {
      document.getElementById('loading') && (document.getElementById('loading').style.display = 'block')
      this.cityId = GlobalEnv.locationInfo.cityId
      this.cates = []
      this.activeCate = 0
      await this.getHomePage()
      document.getElementById('loading') && (document.getElementById('loading').style.display = 'none')
    }
    if (!this.firstRequest) {
      // 添加请求省钱卡列表
      await this.getCardListData()
    }
  },
  data() {
    return {
      EnumMallPageStatus,
      // 当前页面
      pageStatus: EnumMallPageStatus.SaveMoneySet,
      // 省钱区域
      moneySavingBar: {
        moneySaving: 0,
        availabelCoupons: 0,
        bubbleImage: '',
      },
      moneySavingPop: {
        show: false,
        info: {},
      },
      // 推荐位
      activitiesInProgress: {
        type: -1,
        goods: [],
        algorithmEvent: {
          eventInfo: null,
          eventUrl: '',
        },
      },
      // 主商品列表区域
      cates: [],
      activeCate: 0,
      // 省钱卡列表区域
      cardList: [],
      existCard: false,
      // 环境类
      isPassenger: is('passenger'),
      isMiniProgram: is('miniprogram'),
      // 其他
      cityName: '',
      cityId: '',
      ABTest: {
        AllGoodsType: 1,
      },
      cardSavingMoney: {},
      firstRequest: true,
      GlobalEnv,
      pageErrno: 0,
      onPageShow: null,
    }
  },
  computed: {
    isBrowser() {
      return !this.isPassenger && !this.isMiniProgram
    },
    isLogin() {
      return GlobalEnv.isLogin
    },
    showPayCardTab() {
      return +URLQueries.getQuery('page_tab_id') === EnumMallPageStatus.SaveMoneyCard
    },
  },
  methods: {
    async getHomePage() {
      try {
        const params = {
          source_id: GlobalEnv.channelId,
          partition_id: getParamsPartitionIdByXenv(),
          token: GlobalEnv.loginInfo.token,
          terminal: GlobalEnv.terminal,
          city_id: GlobalEnv.locationInfo.cityId,
          lat: GlobalEnv.locationInfo.lat,
          lng: GlobalEnv.locationInfo.lng,
          lang: GlobalEnv.lang,
          recommend_top_id: query().recommend_top_id || '',
          xenv: xenv(),
          cate_id: URLQueries.getQuery('only_show_cate') || '',
        }
        window.PerfTrack?.requestBegin?.()
        console.log('-getHomePage--1-')
        const { cate_list, recommend, saving, group_name, history_bubble } = await request.get(GlobalConfig.APIs.homepage, params)
        console.log('-getHomePage-2--')
        window.PerfTrack?.responseReady?.()
        this.cityName = cate_list.city_name
        // 省钱处理
        this.moneySavingBar.moneySaving = saving?.amount
        this.moneySavingBar.availabelCoupons = saving?.coupon_num
        this.moneySavingBar.bubbleImage = history_bubble || ''
        this.moneySavingPop.info = saving ?? {}
        // 推荐位处理
        this.activitiesInProgress.type = recommend.type === 0 ? EnumUIActivitiesInProgressType.Recommends : EnumUIActivitiesInProgressType.InProgress
        this.activitiesInProgress.goods = recommend.info || []
        if (recommend.event_info?.EventURL) {
          this.activitiesInProgress.algorithmEvent.event_info = recommend.event_info.EventInfo
          this.activitiesInProgress.algorithmEvent.event_url = recommend.event_info.EventURL
        }
        // 主商品分类处理
        const specifiedCateId = URLQueries.getQuery('cate')
        if (specifiedCateId) {
          const index = cate_list.cate.findIndex(cate => `${cate.id}` === `${specifiedCateId}`)
          if (index > -1) {
            const specifiedCate = cate_list.cate.splice(index, 1)[0]
            cate_list.cate.splice(1, 0, specifiedCate)
            this.activeCate = Number(specifiedCateId)
          }
        }
        // ABTest 处理
        if ( group_name ) {
          if (group_name === 'control_group' || group_name === 'group_recommend_old') {
            this.ABTest.AllGoodsType = 2 // 用老列表
          }
        }
        this.cates = cate_list.cate || []
        this.$nextTick(() => {
          window.PerfTrack?.domReady?.({ isKey: true })
          preloadTrack()
          // try {
          //   window.Omega.trackPageCompleted && window.Omega.trackPageCompleted({
          //     time: window.performance?.now?.() || Date.now(),
          //     is_key: 1,
          //   })
          // } catch (error) {}
          callIsLogin()
        })

        window.PerfTrack?.coreImageReady?.({ url: 'https://ut-static.udache.com/webx/fe-agility-wyc/09bRfuxtEAz0YndEWBjQm.png' })
        window.PerfTrack?.customTTI?.({
          resources: this.activitiesInProgress.goods.map(good => good.goods_pic),
        })
        TrackMap.index.exposed()
      } catch (error) {
        console.log('---homepage---error', error)
        const errorData = error.extra || {}
        this.pageErrno = dealPageErrno(errorData)
        MASErrorTrackIndexHomePageError(getErrorMessage(error, {
          friendly: false,
        }), error)
      }
    },
    async getCardListData() {
      if (is('harmonyos')) return
      if (![ 'alimp', 'wxmp', 'passenger' ].includes(xenv())) return
      if (GlobalEnv.lang !== 'zh-CN') return
      // 自动续费需要参数
      let assKey
      if (xenv() === 'wxmp') {
        assKey = 9
      } else if (xenv() === 'alimp') {
        assKey = 22
      } else {
        assKey = is('android') ? 2 : 1
      }
      try {
        const { errno, data } = await getCardList({
          token: GlobalEnv.loginInfo.token,
          city_id: GlobalEnv.locationInfo.cityId,
          access_key_id: assKey,
        })
      if (errno === 0 && data?.list?.length) {
          this.cardList = data.list || []
          this.cardSavingMoney = data.save || {}
          this.existCard = true
          if (this.showPayCardTab) {
            this.pageStatus = EnumMallPageStatus.SaveMoneyCard
          }
        } else {
          this.existCard = false
          this.pageStatus = EnumMallPageStatus.SaveMoneySet
        }
      } catch(error) {
        this.existCard = false
        this.pageStatus = EnumMallPageStatus.SaveMoneySet
      }
    },
    async updateRecommend() {
      const res = await request.get(GlobalConfig.APIs.updateIndexRecommend, {
        source_id: GlobalEnv.channelId,
        partition_id: getParamsPartitionIdByXenv(),
        token: GlobalEnv.loginInfo.token,
        terminal: GlobalEnv.terminal,
        city_id: GlobalEnv.locationInfo.cityId,
        lat: GlobalEnv.locationInfo.lat,
        lng: GlobalEnv.locationInfo.lng,
        lang: GlobalEnv.lang,
        recommend_top_id: query().recommend_top_id || '',
      })
      const recommend = res.recommend || {}
      // 推荐位处理
      this.activitiesInProgress.type = recommend.type === 0 ? EnumUIActivitiesInProgressType.Recommends : EnumUIActivitiesInProgressType.InProgress
      this.activitiesInProgress.goods = recommend.info || []
      if (recommend.event_info?.EventURL) {
        this.activitiesInProgress.algorithmEvent.event_info = recommend.event_info.EventInfo
        this.activitiesInProgress.algorithmEvent.event_url = recommend.event_info.EventURL
      }
    },
    onChangePage(ori){
      // 省钱卡点击埋点
      track('wyc_ckh5_trippackage_list_tab_ck', '省钱卡tab点击', {
        btn_type: ori.detail,
      })
      if (ori.detail === 2) {
        // 省钱卡列表曝光埋点
        track('wyc_ckh5_trippackage_list_savecard_sw', '省钱卡商品列表曝光')
      }
      this.pageStatus = ori.detail
    },
    onMoneySavingClick() {
      this.moneySavingPop.show = true
    },
    onCardMoneySavingClick() {
      // 省钱卡省钱记录点击埋点
      track('wyc_ckh5_trippackage_list_card_savehistory_ck', '省钱卡省钱记录点击')
      if (+this.cardSavingMoney?.save_money) {
        this.moneySavingPop.show = true
      }
    },
    onMoneySavingPopClose() {
      this.moneySavingPop.show = false
    },
    onShareClick() {
      if (cannotUseHarmonyosShare()) {
        mpx.showToast({
          title: '抱歉，当前APP系统版本不支持该操作，可以在升级版本后尝试此操作',
          icon: 'none',
          duration: 2000,
        })
        return
      }
      if (xenv() === 'h5') {
        mpx.showToast({
          title: this.$t('common.h5ShareToast'),
          icon: 'none',
          duration: '3000',
        })
        return
      }
      canIUse('invokeShare') && invokeShare(this.shareData)
      TrackMap.index.click(TrackMap.index.click.CKType.ShareBtn)
    },
    async onLogin() {
      document.getElementById('loading') && (document.getElementById('loading').style.display = 'block')
      this.cates = []
      this.activeCate = 0
      await initEnv({ needLocation: true })
      this.cityId = GlobalEnv.locationInfo.cityId
      await this.getHomePage()
      document.getElementById('loading') && (document.getElementById('loading').style.display = 'none')
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"backgroundColor":"#E83C2C"},
    // @ts-ignore
    {},
    // @ts-ignore
    {'error-page':getComponent(require("../../components/common/error-page.mpx?component=true&componentId=error-pagebda7909e")),'pay-card':()=>import("../../components/pay_card_mall/pay-card.mpx?async=pay_card&component=true&componentId=pay-card76f356ad").then(res => getComponent(res)),'money-saving-card-tips':()=>import("../../components/pay_card_mall/money-saving-card-tips.mpx?async=money_saving_card_tips&component=true&componentId=money-saving-card-tips52662df2").then(res => getComponent(res)),'tab-bar':getComponent(require("../../components/index-v2/tab_bar.mpx?component=true&componentId=tab_barbaa3b8b4")),'popup-save-money':()=>import("../../components/index/save-money.mpx?async=popup&component=true&componentId=save-moneyb85cd07c").then(res => getComponent(res)),'money-saving-tips':getComponent(require("../../components/index-v2/money_saving_tips.mpx?component=true&componentId=money_saving_tips0de9f19b")),'activities-in-progress':getComponent(require("../../components/index-v2/activities_in_progress.mpx?component=true&componentId=activities_in_progress1d5a3a46")),'login-control':getComponent(require("../../components/index-v2/login.mpx?component=true&componentId=login72216026")),'btn-city-select':getComponent(require("../../components/index-v2/navigation_bar/components/btn_city_select.mpx?component=true&componentId=btn_city_select4c940890")),'navigation-bar':getComponent(require("../../components/index-v2/navigation_bar/index.mpx?component=true&componentId=index5fa6267c")),'goods-list':getComponent(require("../../components/index-v2/goods_list/index.mpx?component=true&componentId=indexcae6158a"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
